(function ($) {
  var QuizResults = {
    results: [],
    stageGetResults: function (quizAnswers) {
      // clone the results
      var results = QuizResults.results.slice(0);
      var uniqueResults;

      Object.keys(quizAnswers).forEach(function (key) {
        var value = quizAnswers[key]; // the selected answer
        var filteredResults = QuizResults.filterResults(results, key, value);

        // if there are still products after filtering, we use the filtered list, if not, we just ignore the question
        if (filteredResults.length > 0) {
          results = filteredResults;
        }
      });

      uniqueResults = QuizResults.removeDuplicates(results, 'productVal');
      if (uniqueResults.length === 1) {
        return uniqueResults.map(function (result) {
          return result.$el;
        });
      } else {
        return null;
      }
    },

    getResults: function (quizAnswers) {
      // clone the results
      var results = QuizResults.results.slice(0);

      Object.keys(quizAnswers).forEach(function (key) {
        var value = quizAnswers[key]; // the selected answer
        var filteredResults = QuizResults.filterResults(results, key, value);

        // if there are still products after filtering, we use the filtered list, if not, we just ignore the question
        if (filteredResults.length > 0) {
          results = filteredResults;
        }
      });

      var uniqueResults = QuizResults.removeDuplicates(results, 'productVal');

      return uniqueResults.map(function (result) {
        return result.$el;
      });
    },

    removeDuplicates: function (arr, prop) {
      return arr.filter(function (obj, pos, _arr) {
        return (
          _arr
            .map(function (mapObj) {
              return mapObj[prop];
            })
            .indexOf(obj[prop]) === pos
        );
      });
    },

    filterResults: function (results, _key, value) {
      // _key is received as 'question1', 'question2', etc, we just append 'Answer' to it, getting 'question1Answer'
      var key = _key + 'Answer';
      var ansArray = [];
      var returnedArray = [];

      results.forEach(function (result) {
        if (result[key]) {
          ansArray = result[key].split(',');
          ansArray.forEach(function (answer) {
            if (answer === value || answer === '*') {
              returnedArray.push(result);
            }
          });
        }
      });

      return returnedArray;
    },

    collectResultValues: function (idx, element) {
      var resultValues = $(element).data();

      resultValues.$el = $(element);
      QuizResults.results.push(resultValues);
    },

    attach: function (context) {
      $('.moisturizer-repromote-results', context).once(function (idx, element) {
        var $module = $(element);
        var classResult = 'mr-result',
          selectorResult = '.' + classResult;

        $module.find(selectorResult).each(QuizResults.collectResultValues);
      });
    }
  };

  Drupal.behaviors.mr_quiz_results_formatter_v1 = QuizResults;
})(jQuery);
